<template>
  <notification
    :type="variant"
    :icon="getVariantIcon"
    :title="getVariantTitle"
    classes="custom-toast">
    <p v-if="message">{{ message }}</p>
  </notification>
</template>

<script>
// Components
export default {
  name: "Toast",
  props: {
    message: { type: String, default: null },
    variant: { type: String, default: "success" },
  },
  computed: {
    getVariantIcon() {
      return this.variant === "success"
        ? "check-circle"
        : this.variant === "error"
        ? "times-circle"
        : this.variant === "warning"
        ? "exclamation-circle"
        : "info-circle";
    },
    getVariantTitle() {
      return this.variant === "success"
        ? "Success"
        : this.variant === "error"
        ? "Error"
        : this.variant === "warning"
        ? "Warning"
        : "Info";
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-toast {
  display: flex;
}
</style>

<style lang="scss">
.Vue-Toastification__toast.Vue-Toastification__toast--default {
  padding: 0;
}
</style>
